import { DialogContent } from "@mui/material";

import SimpleDialog from "../../../../SimpleDialog";
import { type BillingProfileInvoiceBucket } from "../../../BillingProfileForm.models";

const DeleteBucketDialog = ({
  bucketToDelete,
  deleteBucket,
  onClose,
}: {
  bucketToDelete: BillingProfileInvoiceBucket;
  deleteBucket: (bucket: BillingProfileInvoiceBucket) => void;
  onClose: () => void;
}) => (
  <SimpleDialog
    open={true}
    onConfirm={() => {
      deleteBucket(bucketToDelete);
      onClose();
    }}
    confirmButtonColor="error"
    title="Confirm deletion"
    onCancel={() => {
      onClose();
    }}
    dialogProps={{
      fullWidth: true,
      maxWidth: "xs",
    }}
  >
    <DialogContent sx={{ mt: 2 }} data-cy="delete-bucket-dialog-content">
      Are you sure you want to delete the bucket "{bucketToDelete.name}"? This action cannot be undone.
    </DialogContent>
  </SimpleDialog>
);

export default DeleteBucketDialog;
